import React from 'react';
import { IFieldProps } from './IFieldProps';
import { eFeePropertyNames } from '../../../../../../types/order/fees/eFeePropertyNames';
import { SelectField } from '../../../../../../ui-toolkit';
import { useHasFeatureFlag } from '../../../../../../selectors/useHasFeatureFlag';
import { getRecordingPartyOptions } from '../../../../../../components/cdBuilder/utilities/recordingPartyOptions';

export const RecordingParty: React.FC<IFieldProps> = ({ baseName, readOnly }) => {
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const options = getRecordingPartyOptions(isSpruceWithZillowEnabled);

  return (
    <SelectField
      label={'Recording Party'}
      options={options}
      name={`${baseName}.stringFeePropertyValues.${eFeePropertyNames.RecordingParty}`}
      data-test-id={'fee-detail-recording-party'}
      isDisabled={readOnly}
      isClearable={false}
    />
  );
};
